import { render, staticRenderFns } from "./SlidesPage.vue?vue&type=template&id=e8ef85f4&scoped=true&"
import script from "./SlidesPage.vue?vue&type=script&lang=ts&"
export * from "./SlidesPage.vue?vue&type=script&lang=ts&"
import style0 from "./SlidesPage.vue?vue&type=style&index=0&id=e8ef85f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ef85f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VIcon,VTab,VTabItem,VTabs})
